export * from './Deferred';

import Deferred from './Deferred';
export default Deferred;
